import { Expose, plainToInstance, Type } from "class-transformer";
import {
  IsDate,
  IsJSON,
  IsNotEmpty,
  IsOptional,
  IsString,
  ValidateNested,
} from "class-validator";
import { SurveyQuestion } from "../survey/survey-question.entity";

export class SurveyQuestionResponse {
  public static from(surveyQuestionResponse: SurveyQuestionResponse) {
    return plainToInstance(SurveyQuestionResponse, surveyQuestionResponse, {
      excludeExtraneousValues: true,
    });
  }

  @Expose()
  @IsString()
  @IsNotEmpty()
  surveyResponseId!: string;

  @Expose()
  @IsString()
  @IsNotEmpty()
  surveyQuestionId!: string;

  @Expose()
  @IsString()
  @IsOptional()
  questionKey?: string;

  @Expose()
  @IsJSON()
  @IsNotEmpty()
  response!: string;

  @Expose()
  @IsDate()
  createdTs!: Date;

  @Expose()
  @IsDate()
  updatedTs?: Date | null;

  @Expose()
  @ValidateNested()
  @IsOptional()
  @Type(() => SurveyQuestion)
  surveyQuestion?: SurveyQuestion;
}
